import { useMemo, useCallback } from 'react';
import { useLocation, useRouteMatch, useHistory, generatePath } from 'react-router-dom';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
var getQueryParamsAsObject$1 = function getQueryParamsAsObject$1(search) {
  var params = {};
  new URLSearchParams(search).forEach(function (_, key) {
    var keyValues = new URLSearchParams(search).getAll(key);
    // default array key
    if (key.endsWith('[]')) {
      var keyName = key.slice(0, -2);
      params[keyName] = keyValues;
      // empty array key
    } else if (key.endsWith('[-]')) {
      var keyName = key.slice(0, -3);
      params[keyName] = [];
      // string key
    } else {
      params[key] = keyValues[0];
    }
  });
  return params;
};
var removeUndefined$1 = function removeUndefined$1(obj) {
  return Object.keys(obj).filter(function (key) {
    return obj[key] !== undefined;
  }).reduce(function (acc, key) {
    var _a;
    return _assign(_assign({}, acc), (_a = {}, _a[key] = obj[key], _a));
  }, {});
};
var arrayToQueryParams = function arrayToQueryParams(key, values) {
  return values.length === 0 ? "".concat(key, "[-]=") : values.map(function (value) {
    return "".concat(key, "[]=").concat(value);
  }).join('&');
};
var objectToQueryParams$1 = function objectToQueryParams$1(obj) {
  return '?' + Object.entries(obj).filter(function (_a) {
    _a[0];
    var value = _a[1];
    return value !== undefined;
  }).map(function (_a) {
    var key = _a[0],
      value = _a[1];
    return Array.isArray(value) ? arrayToQueryParams(key, value) : "".concat(key, "=").concat(value);
  }).join('&');
};
var useDecodedLocation$1 = function useDecodedLocation$1() {
  var _a = useLocation(),
    search = _a.search,
    rest = __rest(_a, ["search"]);
  var decodedSearch = useMemo(function () {
    return getQueryParamsAsObject$1(search);
  }, [search]);
  return _assign({
    search: decodedSearch
  }, rest);
};
var useDecodedRouteMatch$1 = function useDecodedRouteMatch$1() {
  var _a = useRouteMatch(),
    params = _a.params,
    rest = __rest(_a, ["params"]);
  var decodedParams = useMemo(function () {
    return decodeValues$1(params);
  }, [params]);
  return _assign({
    params: decodedParams
  }, rest);
};
var decodeValues$1 = function decodeValues$1(obj) {
  var data = Object.keys(obj).reduce(function (acc, key) {
    acc[key] = obj[key] && decodeURIComponent(obj[key]);
    return acc;
  }, {});
  return data;
};
var encodeValues$1 = function encodeValues$1(obj) {
  var data = Object.entries(removeUndefined$1(obj)).reduce(function (acc, _a) {
    var key = _a[0],
      value = _a[1];
    if (Array.isArray(value)) {
      acc[key] = value.map(encodeURIComponent);
    } else {
      acc[key] = value && encodeURIComponent(value);
    }
    return acc;
  }, {});
  return data;
};
var getQueryParamsAsObject = function getQueryParamsAsObject(search) {
  var params = {};
  new URLSearchParams(search).forEach(function (value, key) {
    return params[key] = value;
  });
  return params;
};
var removeUndefined = function removeUndefined(obj) {
  return Object.keys(obj).filter(function (key) {
    return obj[key] !== undefined;
  }).reduce(function (acc, key) {
    var _a;
    return _assign(_assign({}, acc), (_a = {}, _a[key] = obj[key], _a));
  }, {});
};
var objectToQueryParams = function objectToQueryParams(obj) {
  return '?' + Object.keys(obj).filter(function (key) {
    return obj[key] !== undefined;
  }).map(function (key) {
    return "".concat(key, "=").concat(obj[key]);
  }).join('&');
};
var useDecodedLocation = function useDecodedLocation() {
  var _a = useLocation(),
    search = _a.search,
    rest = __rest(_a, ["search"]);
  var decodedSearch = useMemo(function () {
    return getQueryParamsAsObject(search);
  }, [search]);
  return _assign({
    search: decodedSearch
  }, rest);
};
var useDecodedRouteMatch = function useDecodedRouteMatch() {
  var _a = useRouteMatch(),
    params = _a.params,
    rest = __rest(_a, ["params"]);
  var decodedParams = useMemo(function () {
    return decodeValues(params);
  }, [params]);
  return _assign({
    params: decodedParams
  }, rest);
};
var decodeValues = function decodeValues(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    var _a;
    return _assign(_assign({}, acc), (_a = {}, _a[key] = obj[key] && decodeURIComponent(obj[key]), _a));
  }, {});
};
var encodeValues = function encodeValues(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    var _a;
    return _assign(_assign({}, acc), (_a = {}, _a[key] = obj[key] && encodeURIComponent(obj[key]), _a));
  }, {});
};

/**
 *
 * @deprecated Use `useQueryString`
 */
var useQueryAsState = function useQueryAsState(defaultValues) {
  var _a = useDecodedLocation(),
    pathname = _a.pathname,
    search = _a.search;
  var history = useHistory();
  var updateQuery = useCallback(function (updatedParams) {
    history.replace(pathname + objectToQueryParams(encodeValues(_assign(_assign({}, search), updatedParams))));
  }, [search, pathname, history]);
  var queryWithDefault = useMemo(function () {
    return Object.assign({}, defaultValues, removeUndefined(search));
  }, [search, defaultValues]);
  return [queryWithDefault, updateQuery];
};
/**
 *
 * @deprecated Use `useQueryStringKey`
 */
var useQueryKeyAsState = function useQueryKeyAsState(key, defaultValue) {
  var _a;
  var _b = useQueryAsState(defaultValue === undefined ? undefined : (_a = {}, _a[key] = defaultValue, _a)),
    _c = key,
    value = _b[0][_c],
    updateQuery = _b[1];
  var updateKey = useCallback(function (newValue) {
    var _a;
    return updateQuery((_a = {}, _a[key] = newValue, _a));
  }, [updateQuery, key]);
  return [value, updateKey];
};
/**
 *
 * @deprecated Use `useRouteParams`
 */
var useParamsAsState = function useParamsAsState(defaultValues) {
  var _a = useDecodedRouteMatch(),
    path = _a.path,
    params = _a.params;
  var history = useHistory();
  var updateParams = useCallback(function (updatedParams) {
    history.push(generatePath(path, encodeValues(_assign(_assign({}, params), updatedParams))));
  }, [path, params, history]);
  var paramsWithDefault = useMemo(function () {
    return Object.assign({}, defaultValues, removeUndefined(params));
  }, [params, defaultValues]);
  return [paramsWithDefault, updateParams];
};
var useQueryString = function useQueryString(defaultValues) {
  var _a = useDecodedLocation$1(),
    pathname = _a.pathname,
    search = _a.search;
  var history = useHistory();
  var updateQuery = useCallback(function (dispatch) {
    var updatedParams = typeof dispatch === 'function' ? dispatch(search) : dispatch;
    history.replace(pathname + objectToQueryParams$1(encodeValues$1(updatedParams)));
  }, [search, pathname, history]);
  var queryWithDefault = useMemo(function () {
    return Object.assign({}, defaultValues, removeUndefined$1(search));
  }, [search, defaultValues]);
  return [queryWithDefault, updateQuery];
};
var useQueryStringKey = function useQueryStringKey(key, defaultValue) {
  var _a;
  var _b = useQueryString(defaultValue === undefined ? undefined : (_a = {}, _a[key] = defaultValue, _a)),
    _c = key,
    value = _b[0][_c],
    updateQuery = _b[1];
  var updateKey = useCallback(function (dispatch) {
    var newValue = typeof dispatch === 'function' ? dispatch(value) : dispatch;
    newValue === undefined ? updateQuery(function (_a) {
      var _b = key;
      _a[_b];
      var rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
      return rest;
    }) : updateQuery(function (prev) {
      var _a;
      return _assign(_assign({}, prev), (_a = {}, _a[key] = newValue, _a));
    });
  }, [updateQuery, key, value]);
  return [value, updateKey];
};
var useRouteParams = function useRouteParams(defaultValues) {
  var _a = useDecodedRouteMatch$1(),
    path = _a.path,
    params = _a.params;
  var history = useHistory();
  var updateParams = useCallback(function (dispatch) {
    var updatedParams = typeof dispatch === 'function' ? dispatch(params) : dispatch;
    history.push(generatePath(path, encodeValues$1(updatedParams)));
  }, [path, params, history]);
  var paramsWithDefault = useMemo(function () {
    return Object.assign({}, defaultValues, removeUndefined$1(params));
  }, [params, defaultValues]);
  return [paramsWithDefault, updateParams];
};
var useUrlState = function useUrlState(defaultValues) {
  var history = useHistory();
  var _a = useDecodedRouteMatch$1(),
    path = _a.path,
    params = _a.params;
  var search = useDecodedLocation$1().search;
  var updateUrl = useCallback(function (dispatch) {
    var updatedState = typeof dispatch === 'function' ? dispatch({
      params: params,
      query: search
    }) : dispatch;
    var updatedParams = encodeValues$1(updatedState.params);
    var updatedQuery = objectToQueryParams$1(encodeValues$1(updatedState.query));
    history.push(generatePath(path, updatedParams) + updatedQuery);
  }, [history, params, path, search]);
  var stateWithdefaults = useMemo(function () {
    return {
      params: Object.assign({}, defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.params, removeUndefined$1(params)),
      query: Object.assign({}, defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.query, removeUndefined$1(search))
    };
  }, [defaultValues, params, search]);
  return [stateWithdefaults, updateUrl];
};
export { useParamsAsState, useQueryAsState, useQueryKeyAsState, useQueryString, useQueryStringKey, useRouteParams, useUrlState };